import { render, staticRenderFns } from "./fund-search-no-result.vue?vue&type=template&id=bdfadfe4&scoped=true&lang=pug"
import script from "./fund-search-no-result.vue?vue&type=script&setup=true&lang=js"
export * from "./fund-search-no-result.vue?vue&type=script&setup=true&lang=js"
import style0 from "./fund-search-no-result.vue?vue&type=style&index=0&id=bdfadfe4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdfadfe4",
  null
  
)

export default component.exports